<template>
  <div class="login">
    <Login/>
  </div>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/forms/Login.vue'

export default {
  name: 'HomeView',
  components: {
    Login
  }
}
</script>
